// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__P2iyH","label":"Section_label__3CZoh","contentWrap":"Section_contentWrap__36Sli","footer":"Section_footer__2A9f7","footerInner":"Section_footerInner__1gHkm"};